import { createFileRoute } from '@tanstack/react-router';
import { ReviewSubmissionPage } from 'src/features/community-hub/components/form-review';

/**
 * A student's Hands-On Practice submission opened from a Teacher Review sub-space.
 * Path: /programs/{program}/{review-sub-space}/review/{submissionId}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/review/$submissionId')({
  component: ReviewSubmissionRoute,
});

function ReviewSubmissionRoute() {
  const { submissionId } = Route.useParams();
  return <ReviewSubmissionPage submissionId={submissionId} />;
}
